module.exports = [{"regex":"NetFront","name":"NetFront"},{"regex":"Edge","name":"Edge"},{"regex":"Trident","name":"Trident"},{"regex":"Blink","name":"Blink"},{"regex":"(?:Apple)?WebKit","name":"WebKit"},{"regex":"Presto","name":"Presto"},{"regex":"(?<!like )Gecko","name":"Gecko"},{"regex":"KHTML","name":"KHTML"},{"regex":"NetSurf","name":"NetSurf"},{"regex":"Servo","name":"Servo"},{"regex":"Goanna","name":"Goanna"}]


//////////////////
// WEBPACK FOOTER
// ./~/device-detector-js/dist/fixtures/regexes/client/browser_engine.json
// module id = 855
// module chunks = 113